// extracted by mini-css-extract-plugin
export default {"data_box":"index_data_box_ouDi-","green":"index_green_IMaHN"};